export default "__VITE_ASSET__1yRaEmIG__"